import React, { useContext, useState } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
import ProgressButtons from "../ProgressButtons";
import SubFormButtons from "../SubFormButtons";
import livingStatusList from "../../../data/livingStatusList";
import states from "../../../data/states";
import { useEffect } from "react";
import findBrand from "../../findBrand";
import { brandDomains, fetchBrands } from "../../brand";
import countriesList from "../../../data/countriesList";

const R4PhysicalAddress = () => {
  const registrationContext = useContext(RegistrationContext);
  const {
    subFormLevels,
    onFormDataChange,
    pass: { physicalAddress },
    formData: {
      liveWithPg,
      liveinUS,
      livingStatus,
      firstName,
      street,
      city,
      state,
      zip,
      addressfield,
      county,
      isMailingAddressTheSame,
    },
  } = registrationContext;
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [Cstate, setState] = useState(state || "");

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(
        "https://raw.githubusercontent.com/dr5hn/countries-states-cities-database/master/json/countries%2Bstates.json"
      );
      const data = await response.json();

      // Reorder countries to have "USA" at the top
      const reorderedCountries = data.sort((a, b) =>
        a.name === "United States" ? -1 : b.name === "United States" ? 1 : 0
      );

      setCountries(reorderedCountries);

      // Set filtered states if a country is already selected
      if (county) {
        const countryData = reorderedCountries.find(
          (item) => item.name === county
        );
        if (countryData?.states) {
          const stateNames = countryData.states.map((state) =>
            typeof state === "object" ? state.name : state
          );
          setFilteredStates(stateNames);
        }
      }
    };

    fetchData();
  }, [county]);

  // Update states list based on selected country
  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    setCountry(selectedCountry);
    const countryData = countries.find((item) => item.name === selectedCountry);
    if (countryData?.states) {
      const stateNames = countryData.states.map((state) =>
        typeof state === "object" ? state.name : state
      );
      setFilteredStates(stateNames);
    } else {
      setFilteredStates([]);
    }
    onFormDataChange({ target: { name: "county", value: selectedCountry } });
    onFormDataChange({ target: { name: "zip", value: "" } });
    setState("");
  };

  const handleStateChange = (e) => {
    setState(e.target.value);
    onFormDataChange({ target: { name: "state", value: e.target.value } });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    e.target.value =
      value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    onFormDataChange(e);
  };

  const validateZipCode = (zip) => {
    //holston and pbia Forms
    if (country === "United States") {
      return /^\d{5}$/.test(zip); // USA ZIP Code: Exactly 5 digits
    }
    return /^\d{0,15}$/.test(zip);
  };

  const handleZipChange = (e) => {
    //holston and pbia Forms
    const { value } = e.target;

    if (country === "United States") {
      // Allow only numbers and max 5 digits for USA
      if (!/^\d{0,5}$/.test(value)) return;
    } else {
      // Allow only numbers and max 10 digits for other countries
      if (!/^\d{0,15}$/.test(value)) return;
    }

    onFormDataChange({ target: { name: "zip", value } });
  };

  const validatezipCode = (e) => {
    const re = /^\d{5}$/;
    return re.test(String(e).toLowerCase());
  };

  const handleChange1 = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      var aVal = e.target.value;
      if (aVal.length < 5) {
        e.target.value = aVal;
      }
    }
    onFormDataChange(e);
  };

  const addressinfo =
    liveWithPg !== "" &&
    street !== "" &&
    livingStatus !== "" &&
    state !== "" &&
    county !== "" &&
    city !== "" &&
    zip !== "" &&
    validatezipCode(zip) &&
    isMailingAddressTheSame !== "";

  const addressinfo2 =
    state !== "" &&
    county !== "" &&
    city !== "" &&
    street !== "" &&
    zip !== "" &&
    validateZipCode(zip) &&
    isMailingAddressTheSame !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  //findBrand is used to check whether holston forms or other forms
  if (findBrand(brand_holston) === true || findBrand(brand_pbia) === true) {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Physical Address <span>(5/11)</span>
            <hr />
          </h2>

          <div className="item">
            <div className="asterisk-group">
              <h3>Street</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="street"
              maxLength="50"
              onChange={(e) => onFormDataChange(e)}
              value={street}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : street !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>City/Town</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="city"
              maxLength="50"
              onChange={(e) => onFormDataChange(e)}
              value={city}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : city !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>
          <div className="item">
            <div className="asterisk-group">
              <h3>Country</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="county"
              value={county}
              onChange={handleCountryChange}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : county !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select</option>
              {countries.map((item) => (
                <option key={item.name} value={item.name}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* State Selector */}
          <div className="item">
            <div className="asterisk-group">
              <h3>State/Province/Region</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="Cstate"
              value={Cstate}
              onChange={handleStateChange}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : Cstate !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select</option>
              {filteredStates.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3> Zip/Postal Code </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="zip"
              maxLength={county === "United States" ? "5" : "15"}
              required
              onChange={handleZipChange}
              value={zip}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc"
                  : zip !== ""
                  ? "1px solid #ccc"
                  : "2px solid #d8302f",
              }}
            />
            {zip !== "" && !validateZipCode(zip) && (
              <p className="validEmail">
                Please provide a valid Zip/Postal Code
              </p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Is Mailing Address the Same?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : isMailingAddressTheSame !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={isMailingAddressTheSame["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="isMailingAddressTheSame"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={isMailingAddressTheSame["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="isMailingAddressTheSame"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div className="group">{subFormLevels.physicalAddress === 0}</div>
        <ProgressButtons validation={addressinfo2} name="physicalAddress" />
      </>
    );
  } else {
    return (
      <>
        <div className="sub-form">
          <h2 className="">
            Physical Address <span>(3/15)</span>
            <hr />
          </h2>
          <div className="item">
            <div className="asterisk-group">
              <h3>
                Does {firstName === "" ? "the Student" : firstName} Live With
                Parents?
              </h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : liveWithPg !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={liveWithPg["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="liveWithPg"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={liveWithPg["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="liveWithPg"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>
                What Is {firstName === "" ? "the Student" : firstName}'s Living
                Status?
              </h3>

              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>

            <select
              name="livingStatus"
              value={livingStatus}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : livingStatus !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {livingStatusList.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Street</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              maxLength="50"
              name="street"
              onChange={(e) => handleChange(e)}
              value={street}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : street !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>City</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="city"
              maxLength="50"
              onChange={(e) => handleChange(e)}
              value={city}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : city !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>State</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="state"
              value={state}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : state !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {states.map((item) => {
                return (
                  <option value={Object.keys(item)}>{Object.keys(item)}</option>
                );
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Zip</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <input
              type="text"
              name="zip"
              maxLength="5"
              required
              onChange={(e) => handleChange1(e)}
              value={zip}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : zip !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            />
            {zip !== "" && !validatezipCode(zip) && (
              <p className="validEmail">
                {` Please provide a valid Zip/Postal Code`}
              </p>
            )}
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Country</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <select
              name="county"
              value={county}
              type="text"
              onChange={(e) => onFormDataChange(e)}
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : county !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <option value="">Please Select </option>
              {countriesList.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
          </div>

          <div className="item">
            <div className="asterisk-group">
              <h3>Is Mailing Address the Same?</h3>
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </div>
            <div
              className="flex-check-container"
              style={{
                border: physicalAddress
                  ? "1px solid #ccc;"
                  : isMailingAddressTheSame !== ""
                  ? "1px solid #ccc"
                  : "#d8302f 2px solid",
              }}
            >
              <label className="check-container">
                Yes
                <input
                  type="radio"
                  value="yes"
                  checked={isMailingAddressTheSame["yes"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="isMailingAddressTheSame"
                />
                <span className="styled-checkmark"></span>
              </label>
              <label className="check-container">
                No
                <input
                  type="radio"
                  value="no"
                  checked={isMailingAddressTheSame["no"]}
                  onChange={(e) => onFormDataChange(e)}
                  name="isMailingAddressTheSame"
                />
                <span className="styled-checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div className="group">{subFormLevels.physicalAddress === 0}</div>
        <ProgressButtons validation={addressinfo} name="physicalAddress" />
      </>
    );
  }
};

export default R4PhysicalAddress;
